export default function formatarNumeroTelefone(numero: string): string {
  const codigoPais = "+55";
  const codigoArea = numero?.substring(2, 4);
  const parte1 = numero?.substring(4, 9);
  const parte2 = numero?.substring(9);

  return `${codigoPais} (${codigoArea}) ${parte1}-${parte2}`;
}

export function formatPhoneNumber(str: string) {
  const match: any =
    str?.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/) ||
    str?.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/) ||
    str?.match(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})$/) ||
    str?.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/) ||
    str?.match(/^(\d{2})(\d{3})(\d{3})(\d{3})(\d{1})$/);
  if (match && match.length <= 5) {
    return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
  }
  if (match && match.length > 5) {
    return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`;
  }
  return str;
}
